export const SESSION_TOKENS = {
  ACCESS_TOKEN: 'access-token',
  CLIENT: 'client',
  UID: 'uid',
};

export const SESSION_HEADERS = [
  SESSION_TOKENS.ACCESS_TOKEN,
  SESSION_TOKENS.CLIENT,
  SESSION_TOKENS.UID,
];
